import styled from "@emotion/styled";
import { border as borderToken, controlFontSize, borderRadius, layout, spacing, visuallyHidden } from "@atlas-int/tokens";
import {
  createMainMenu,
  createBaseMenuItem,
  createDropdownContainer,
  createToggleButton,
  ArrowUp as ArrowUpIcon,
  ArrowDown as ArrowDownIcon,
  ClearButton,
  ClearButtonSymbol,
} from "../dropdownPrimitive/styles";

export { ClearButton, ClearButtonSymbol };

export const ArrowUp = ArrowUpIcon;
export const ArrowDown = ArrowDownIcon;

export const MainMenu = createMainMenu({
  maxHeight: layout.menuMaxHeight,
});

const BaseMenuItemInner = createBaseMenuItem({
  itemHeight: "auto",
  itemOverflow: "visible",
});

export const BaseMenuItem = styled(BaseMenuItemInner)`
  align-items: flex-start;
  padding-block: ${spacing[2]};
`;

export const ToggleButton = createToggleButton();

const BaseDropdownContainer = createDropdownContainer({
  containerBorderColor: borderToken.control,
  containerRadius: "0",
});

export const DropdownContainer = styled(BaseDropdownContainer)<{ $iconSrc?: string }>`
  border-bottom-left-radius: ${borderRadius.base};
  border-bottom-right-radius: ${borderRadius.base};

  &::before {
    display: inline-block;
    position: absolute;
    left: 0px;
    top: 0px;
    width: ${spacing[12]};
    height: 100%;
    content: "";
    ${({ $iconSrc }) => $iconSrc ? `background-image: url(${$iconSrc});` : ""}
    background-position: center center;
    background-repeat: no-repeat;
  }
`;

export const DropdownInputField = styled.input`
  width: 100%;
  height: 100%;
  font-size: ${controlFontSize.default};
  box-sizing: border-box;
  border: none;
  padding-left: ${spacing[12]};
  padding-right: ${spacing[20]};
  background: none;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.input--placeholder {
    font-size: ${controlFontSize.sm};
    text-transform: uppercase;
  }
`;

export const ComboBoxContainer = styled.div`
  width: 100%;
  position: relative;
  background: none;
`;

// Visually-hidden label. downshift's getInputProps/getMenuProps reference a
// label id via aria-labelledby, so a real (if invisible) label must exist for
// those references to resolve -- and it gives the search box an accessible name.
export const SrOnlyLabel = styled.label`
  ${visuallyHidden};
`;
